import InamoveStorage from '../../Controllers/StorageController'

export type LevelListItem = {
    id: string
    name: string
    code: string
}

export type LevelList = Readonly<Array<LevelListItem>>

export type GameStartFn = (levelIndex: number) => Promise<void>

type LevelStorage = {
    unlockedLevelId: string
}

const storageId = 'level-list-container'
const initialStorage: LevelStorage = {
    unlockedLevelId: 'intro',
}

class LevelListContainer {
    element = document.querySelector('#level-list-container') as HTMLDivElement
    listElement = document.querySelector('#level-list') as HTMLUListElement
    storage: InamoveStorage<LevelStorage>
    levelList: LevelList = []
    gameStartFn: GameStartFn = () => new Promise((resolve) => resolve())

    constructor() {
        const initialBrowserStorage = InamoveStorage.getInitialStorage<LevelStorage>(storageId)

        this.storage = new InamoveStorage<LevelStorage>(storageId, initialBrowserStorage ?? initialStorage)
    }

    init = (levelList: LevelList, gameStartFn: GameStartFn) => {
        this.levelList = levelList
        this.gameStartFn = gameStartFn

        this.showLevels()
    }

    show = () => {
        this.element.classList.remove('hidden')
    }

    hide = () => {
        this.element.classList.add('hidden')
    }

    unlockLevel = (levelId: string) => {
        const unlockedLevelId = this.storage.getStorage().unlockedLevelId
        const unlockedLevelIndex = this.levelList.findIndex((item) => item.id === unlockedLevelId)
        const levelIdIndex = this.levelList.findIndex((item) => item.id === levelId)

        if (levelIdIndex >= 0) {
            // WHY: unlock only if not already unlocked
            if (unlockedLevelIndex <= levelIdIndex) {
                const entry = this.storage.getStorage()

                this.storage.setStorage({
                    ...entry,
                    unlockedLevelId: levelId,
                })
            } else {
                console.info(
                    `Inamove::LevelList => tried to unlock level "${this.levelList[levelIdIndex].id}" but already unlocked until "${unlockedLevelId}"`
                )
            }
        } else {
            console.info(`Inamove::LevelList => level with "${levelId}" not found!"`)
        }
    }

    showLevels = () => {
        const unlockedLevelId = this.storage.getStorage().unlockedLevelId
        const unlockedLevelIndex = this.levelList.findIndex((item) => item.id === unlockedLevelId)

        if (unlockedLevelIndex < 1) {
            // don't show intro initially
            return
        }

        const trimmedLevelList = this.levelList.slice(0, unlockedLevelIndex + 1)

        this.renderListItems(trimmedLevelList)
    }

    renderListItems = (list: LevelList) => {
        // reset list
        this.listElement.innerHTML = ''

        list.forEach((listItem, index) => {
            const element = document.createElement('li')
            element.setAttribute('role', 'button')
            element.classList.add('level-list__item')

            if (index !== 0 && index < 15) {
                const kapitelNrElement = document.createElement('span')
                kapitelNrElement.innerText = `Kapitel ${index}`
                element.appendChild(kapitelNrElement)
            }

            const nameElement = document.createElement('span')
            nameElement.innerText = listItem.name
            element.appendChild(nameElement)

            element.onclick = async () => {
                return this.gameStartFn(index)
            }

            this.listElement.appendChild(element)
        })
    }

    enableLevelByCode = (code: string) => {
        const unlockedLevelByCodeIndex = this.levelList.findIndex((item) => item.code === code)

        if (unlockedLevelByCodeIndex >= 0) {
            this.unlockLevel(this.levelList[unlockedLevelByCodeIndex].id)
        }
    }
}

export default new LevelListContainer()
